import { render, staticRenderFns } from "./App.vue?vue&type=template&id=cb581660&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.9.8_cache-loader@4.1.0_webpack@4.46.0__css-loader@3.6.0_webpack@4.46.0__lodash@_un4jhf4odrklsfexjnq27ps2iu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports